import { render, staticRenderFns } from "./DialogItemUsers.vue?vue&type=template&id=91e0dbde"
import script from "./DialogItemUsers.vue?vue&type=script&lang=js"
export * from "./DialogItemUsers.vue?vue&type=script&lang=js"
import style0 from "./DialogItemUsers.vue?vue&type=style&index=0&id=91e0dbde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports